import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { View } from 'react-native';
import { TypographyWidget } from '../../../typography-widget';
import { getPriceSectionStyles } from './PriceSectionStyles';
var PriceSection = props => {
  var _a, _b, _c, _d, _e;
  var priceSectionData = props.priceSectionData;
  var _priceSectionData$pri = priceSectionData.priceData,
    price = _priceSectionData$pri.price,
    deposit = _priceSectionData$pri.deposit;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var priceSectionStyles = getPriceSectionStyles();
  var hasPriceSection = ((_a = price === null || price === void 0 ? void 0 : price.newPrice) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_b = price === null || price === void 0 ? void 0 : price.oldPrice) === null || _b === void 0 ? void 0 : _b.length) > 0;
  return _jsxs(_Fragment, {
    children: [hasPriceSection && _jsxs(View, Object.assign({
      style: priceSectionStyles.priceAndGst,
      pointerEvents: "none"
    }, {
      children: [_jsx(TypographyWidget, Object.assign({
        multiText: [Object.assign({
          text: price === null || price === void 0 ? void 0 : price.newPrice
        }, price === null || price === void 0 ? void 0 : price.newPriceAccessibilityProps), (price === null || price === void 0 ? void 0 : price.newPricePostFix) && Object.assign({
          text: " " + ((price === null || price === void 0 ? void 0 : price.newPricePostFix) || ''),
          color: BLACK_700,
          type: "body-para-" + (isLargeScreen ? 'sm' : 'xs')
        }, price === null || price === void 0 ? void 0 : price.newPricePostFixAccessibilityProps)],
        type: "body-single-line-" + (isLargeScreen ? 'xl' : 'md') + "-bold",
        style: priceSectionStyles.priceSpacingWithOldPrice
      }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'newPrice'))), ((_c = price === null || price === void 0 ? void 0 : price.oldPrice) === null || _c === void 0 ? void 0 : _c.length) > 0 && _jsx(TypographyWidget, {
        multiText: [Object.assign({
          text: price === null || price === void 0 ? void 0 : price.oldPrice,
          isStriked: (_d = price === null || price === void 0 ? void 0 : price.isOldPriceStriked) !== null && _d !== void 0 ? _d : true
        }, price === null || price === void 0 ? void 0 : price.oldPriceAccessibilityProps), Object.assign({
          text: " " + ((price === null || price === void 0 ? void 0 : price.oldPricePostFix) || '')
        }, price === null || price === void 0 ? void 0 : price.oldPricePostFixAccessibilityProps)],
        type: "body-single-line-" + (isLargeScreen ? 'sm' : 'xs'),
        color: BLACK_700
      })]
    })), ((_e = deposit === null || deposit === void 0 ? void 0 : deposit.price) === null || _e === void 0 ? void 0 : _e.length) > 0 && _jsx(TypographyWidget, Object.assign({
      text: ((deposit === null || deposit === void 0 ? void 0 : deposit.price) || '') + "  " + ((deposit === null || deposit === void 0 ? void 0 : deposit.postFix) || ''),
      type: "body-para-" + (isLargeScreen ? 'sm' : 'xs'),
      color: BLACK_700,
      style: priceSectionStyles.depositPrice
    }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'deposit')))]
  });
};
export default PriceSection;